import { isNil } from "./isNil";

export const isEmpty = (value: unknown): boolean => {
  // null or undefined
  if (isNil(value)) {
    return true;
  }
  
  // arrays, strings with length property
  if (Array.isArray(value) || typeof value === 'string') {
    return value.length === 0;
  }
  
  // Map or Set with size property
  if (value instanceof Map || value instanceof Set) {
    return value.size === 0;
  }

  // Date and RegExp objects should not be considered empty
  if (value instanceof Date || value instanceof RegExp) {
    return false;
  }
  
  // Plain objects
  if (value !== null && typeof value === 'object' && !Array.isArray(value) && !(value instanceof Map) && !(value instanceof Set)) {
    return Object.keys(value).length === 0;
  }
  
  // numbers, booleans are not considered empty
  return false;
};